module.exports = __webpack_public_path__ + "img/guQuanJiaGouTu.41fffa62.png";